import './customerReview.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CustomerReview = forwardRef((props, ref) => {
  const className = classNames({
    'customer-review': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

CustomerReview.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const CustomerReviewCustomer = forwardRef((props, ref) => {
  const className = classNames({
    'customer-review-customer': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

CustomerReviewCustomer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const CustomerReviewAvatar = forwardRef((props, ref) => {
  const className = classNames({
    'customer-review-avatar': true,
    [props.className]: props.className,
  });

  return <img ref={ref} className={className} src={props.url} alt={props.name} />;
});

CustomerReviewAvatar.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string,
  name: PropTypes.string,
};

CustomerReview.Customer = CustomerReviewCustomer;
CustomerReview.Avatar = CustomerReviewAvatar;

export default CustomerReview;
